import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TenantGuard } from '@segurosvoluntarios_vel/commons-services';
import { environment } from 'src/environments/environment';
import { DatosComponent } from 'src/app/pago/containers/datos/datos.component';
import { ValidacionComponent } from 'src/app/pago/containers/validacion/validacion.component';
import { Ruta } from 'src/app/pago/enums/Ruta.enum';

const routes: Routes = [
  { path: '', redirectTo: '/sura', pathMatch: 'full' },
  {
    path: `:${Ruta.TENANT}`,
    canActivate: [TenantGuard],
    data: {
      tenants: environment.tenants,
      defaultUrlRedirectNotFound: `${environment.suraPath}/${Ruta.PAGINA_NO_ENCONTRADA}`,
    },
    children: [
      {
        path: `${Ruta.VALIDACION}/:${Ruta.ID_PAGO}`,
        component: ValidacionComponent,
      },
      {
        path: `:${Ruta.ID_PAGO}`,
        component: DatosComponent,
      },
      {
        path: '**',
        redirectTo: '/sura',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
